<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :data-cy="`${entityName}__autocomplete--${attributeName}Container`"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!required"
    :showHeader="showHeader"
  >
    <v-autocomplete
      :chips="multiple"
      :deletable-chips="multiple"
      :items="comboboxOptionList"
      :multiple="multiple"
      :data-cy="`${entityName}__autocomplete--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="validatorList"
      :counter="counter"
      :solo="styleMap.solo"
      clearable
      required
      v-model="value"
    ></v-autocomplete>
  </component-wrapper>
</template>

<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  mixins: [userInputMixin],
  props: {
    ruleList: {
      type: Array,
    },
  },
};
</script>
